module.exports = __webpack_public_path__ + "static/media/king-crown.cd109ceb.svg";